"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FoundRequisitionDtoToJSON = exports.FoundRequisitionDtoFromJSONTyped = exports.FoundRequisitionDtoFromJSON = exports.instanceOfFoundRequisitionDto = exports.FoundRequisitionDtoOrderTypeEnum = void 0;
var runtime_1 = require("../runtime");
var FoundRequisitionPatientDto_1 = require("./FoundRequisitionPatientDto");
/**
 * @export
 */
exports.FoundRequisitionDtoOrderTypeEnum = {
    Diagnostic: 'diagnostic',
    Preventive: 'preventive',
    SmaStat: 'sma-stat',
    Stat: 'stat',
    Exome: 'exome',
    ExomePreventiveAddon: 'exome_preventive_addon',
    Carrier: 'carrier',
    Nips: 'nips',
    TumorProfiling: 'tumor_profiling',
    CombiPoc: 'combi_poc',
    CombiRpl: 'combi_rpl',
    CombiCdd: 'combi_cdd',
    CombiPd: 'combi_pd',
    CombiCc: 'combi_cc',
    CombiPfu: 'combi_pfu',
    Wgs: 'wgs',
    Pathogen: 'pathogen',
    Pgx: 'pgx',
    SolidTumor: 'solid_tumor'
};
/**
 * Check if a given object implements the FoundRequisitionDto interface.
 */
function instanceOfFoundRequisitionDto(value) {
    var isInstance = true;
    isInstance = isInstance && "concepts" in value;
    isInstance = isInstance && "formattedStage" in value;
    isInstance = isInstance && "parentReqid" in value;
    isInstance = isInstance && "parentType" in value;
    isInstance = isInstance && "patients" in value;
    isInstance = isInstance && "patientSpecimens" in value;
    isInstance = isInstance && "reportDates" in value;
    isInstance = isInstance && "reqid" in value;
    isInstance = isInstance && "rereqSet" in value;
    isInstance = isInstance && "dateCreated" in value;
    isInstance = isInstance && "prLocked" in value;
    isInstance = isInstance && "rrsLocked" in value;
    isInstance = isInstance && "practiceCountry" in value;
    isInstance = isInstance && "labcorpSpecimenId" in value;
    return isInstance;
}
exports.instanceOfFoundRequisitionDto = instanceOfFoundRequisitionDto;
function FoundRequisitionDtoFromJSON(json) {
    return FoundRequisitionDtoFromJSONTyped(json, false);
}
exports.FoundRequisitionDtoFromJSON = FoundRequisitionDtoFromJSON;
function FoundRequisitionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'concepts': json['concepts'],
        'formattedStage': json['formatted_stage'],
        'orderType': !(0, runtime_1.exists)(json, 'order_type') ? undefined : json['order_type'],
        'parentReqid': json['parent_reqid'],
        'parentType': json['parent_type'],
        'patients': (json['patients'].map(FoundRequisitionPatientDto_1.FoundRequisitionPatientDtoFromJSON)),
        'patientSpecimens': json['patient_specimens'],
        'reportDates': json['report_dates'],
        'reqid': json['reqid'],
        'rereqSet': json['rereq_set'],
        'dateCreated': json['date_created'],
        'prLocked': json['pr_locked'],
        'rrsLocked': json['rrs_locked'],
        'practiceCountry': json['practice_country'],
        'labcorpSpecimenId': json['labcorp_specimen_id'],
    };
}
exports.FoundRequisitionDtoFromJSONTyped = FoundRequisitionDtoFromJSONTyped;
function FoundRequisitionDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'concepts': value.concepts,
        'formatted_stage': value.formattedStage,
        'order_type': value.orderType,
        'parent_reqid': value.parentReqid,
        'parent_type': value.parentType,
        'patients': (value.patients.map(FoundRequisitionPatientDto_1.FoundRequisitionPatientDtoToJSON)),
        'patient_specimens': value.patientSpecimens,
        'report_dates': value.reportDates,
        'reqid': value.reqid,
        'rereq_set': value.rereqSet,
        'date_created': value.dateCreated,
        'pr_locked': value.prLocked,
        'rrs_locked': value.rrsLocked,
        'practice_country': value.practiceCountry,
        'labcorp_specimen_id': value.labcorpSpecimenId,
    };
}
exports.FoundRequisitionDtoToJSON = FoundRequisitionDtoToJSON;
